<template>
  <div>
    <PageLoader />
    <v-app id="app">
      <span style="min-height: 100vh">
        <router-view  v-bind:storage="sideNav" />
      </span>
    </v-app>
  </div>
</template>
<script>
import axios from "axios";

import "./assets/styles/fonts.css";
import "./assets/styles/appStyle.css";

export default {
  data() {
    return {
      sideNav: false,
    };
  },
  beforeMount() {
    if (typeof localStorage.getItem("token") == "string") {
      this.$store.commit("appLoading", true);
      axios({
        method: "GET",
        url: "employee/profile/me",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          isAttendance: true, // Some backends require this to return the full profile
        },
      })
        .then((response) => {
          this.$store.commit("appLoading", false);
          if (response.data.status) {
            const data = response.data.data || {};
            this.$store.commit("userData", data);
            this.$store.commit("fullData", response.data);

            const userRole = response.data.role || data.usertype || data.role;
            if (userRole) this.$store.commit("userType", userRole);

            const posId = response.data.position || data.position || data.positionId;
            if (posId) {
              this.$store.commit("positionId", posId);
            }

            // Robust menu extraction with defensive update
            const menus = response.data.menus || data.menus || response.data.Menus || data.Menus || response.data.menu || data.menu;
            if (menus && Array.isArray(menus) && menus.length > 0) {
              this.$store.commit("menu", menus);
            }
          }
          else {
            // Optional: Handle invalid session
            // this.$store.commit("sessionOut");
          }
        })
        .catch((err) => {
          this.$store.commit("appLoading", false);
          console.error("Profile fetch error:", err);
        });
    }
  },
  methods: {},
};
</script>
